import { tv } from "@ui/lib/tv";
import type { ReactNode } from "react";

const subNav = tv({
  base: "flex items-stretch justify-center gap-6 border-b border-neutral-100 bg-white px-5",
});

export interface SubNavProps {
  children: ReactNode;
  "aria-label": string;
  className?: string;
}

/**
 * A centred strip of `SubNavItem` route links — icon above label, Airbnb-style sub-navigation.
 * Renders a `<nav>` (not a tablist) because each item is a route navigation, mirroring `BottomBar`.
 * Used for sub-section switching within a primary tab (e.g. Programs / Destinations under Explore).
 */
export function SubNav({ children, "aria-label": ariaLabel, className }: SubNavProps) {
  return (
    <nav aria-label={ariaLabel} className={subNav({ className })}>
      {children}
    </nav>
  );
}
